import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BlogPage.css';

const welcomePost = {
  id: 'welcome',
  title: 'An introduction to DocuHounds',
  excerpt:
    'DocuHounds was founded at Boston College by founders with engineering and software backgrounds. DocuHounds Student is a student-first platform that automates syllabus parsing, calendar population, and task organization — launching in 2026 for New England campuses.',
  image: '/blog/welcome.png',
  date: 'October 16, 2025'
};

const betaLaunchPost = {
  id: 'beta-launch',
  title: 'DocuHounds Beta Is Live',
  excerpt:
    'Today we officially opened DocuHounds to the public. After spending the last year building, testing, and refining this platform, we\'re excited to finally launch the DocuHounds beta and put it in the hands of real users.',
  image: '/blog/DocuHounds_beta_live.png',
  date: 'January 12, 2026'
};

const ambassadorPost = {
  id: 'ambassador-program',
  title: 'The DocuHounds Ambassador Program Is Live',
  excerpt:
    'Alongside the beta launch, we\'re officially rolling out the DocuHounds Ambassador Program. This program is about bringing real students into the process early and building DocuHounds the right way.',
  image: '/blog/DocuHounds_ambassador_program.png',
  date: 'February 2, 2026'
};

const builtForPost = {
  id: 'who-docuhounds-is-built-for',
  title: 'Who DocuHounds Is Built For',
  excerpt:
    'DocuHounds was built for the students whose education has to coexist with real life. Work schedules. Commutes. Family responsibilities. Financial pressure. Students who care deeply about school because the stakes are high.',
  image: '/blog/Who_DocuHounds_is_built_for.png',
  date: 'February 8, 2026'
};

export default function BlogPage() {
  const posts = [builtForPost, ambassadorPost, betaLaunchPost, welcomePost];
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="public-page blog-page">
      <main className="container blog-list-container" style={{ padding: '48px 24px' }}>
        <section className="blog-header">
          <h1 className="blog-title">DocuHounds Blog</h1>
          <p className="blog-subtitle">Stories, updates, and insights from the builders of DocuHounds.</p>
          <div className="blog-accent" />
        </section>

        <section className="featured-section">
          <Link to={`/blog/${welcomePost.id}`} className="featured-card">
            <div className="featured-visual">
              <img
                src={welcomePost.image}
                alt="featured"
                className="featured-hero-image"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/logos/blue_docuhounds_text.png';
                }}
              />
              <div className="featured-hero-blur" style={{ backgroundImage: `url(/blog/welcome.png)` }} />
            </div>
            <div className="featured-content">
              <h2 className="featured-title">{welcomePost.title}</h2>
              <p className="featured-excerpt">{welcomePost.excerpt}</p>
              <div className="featured-cta">Read more</div>
            </div>
          </Link>
        </section>

        <section className="posts-grid">
          {posts.map((p) => (
            <article key={p.id} className="article-card-grid">
              <Link to={`/blog/${p.id}`} className="article-card-link">
                <div className="card-thumb">
                  <img
                    src={p.image}
                    alt={p.title}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = '/logos/blue_docuhounds_text.png';
                    }}
                  />
                </div>
                <div className="card-body">
                  <div className="card-date">{p.date}</div>
                  <h3 className="card-title">{p.title}</h3>
                  <p className="card-excerpt">{p.excerpt}</p>
                  <span className="card-read">Read Article →</span>
                </div>
              </Link>
            </article>
          ))}
        </section>
      </main>
    </div>
  );
}
